// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FqlMWiPQRa8Rz4 {
  display: grid;
  grid-template-columns: repeat(4, calc(25% - var(--ds-space-100, 8px)));
  margin: var(--ds-space-050, 4px) var(--ds-space-0, 0) var(--ds-space-200, 16px);
  column-gap: var(--ds-space-100, 8px);
  row-gap: var(--ds-space-100, 8px);
}
.qti6KqAppmG9Wk {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-050, 4px);
  padding: var(--ds-space-0, 0) var(--ds-space-050, 4px);
}
@media only screen and (max-width: 600px) {
  .FqlMWiPQRa8Rz4 {
    grid-template-columns: repeat(3, calc(33.3% - var(--ds-space-100, 8px)));
  }
}
@media only screen and (max-width: 450px) {
  .FqlMWiPQRa8Rz4 {
    grid-template-columns: repeat(auto-fill, minmax(120px, calc(50% - var(--ds-space-100, 8px))));
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardTiles": `FqlMWiPQRa8Rz4`,
	"boardList": `qti6KqAppmG9Wk`
};
export default ___CSS_LOADER_EXPORT___;
